import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Button from "../components/global/button/Button";
import "./ConfirmationModal.scss";
import logo from "../assets/images/logo/app-logo.svg";

const ConfirmationModal = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsConfirmed(value === props.consultantId);
  };

  const handleConfirm = () => {
    if (props?.Id) {
      props.btn1Handler(props?.Id);
    } else {
      props.btn1Handler();
    }
  };

  return (
    <Modal
      size="md"
      centered
      show={props.show}
      dialogClassName="Confirmation-modal"
    >
      <ModalHeader className="justify-content-center">
        <div className="text-center">
          <img src={logo} alt="" height="30" className="ms-4 text-center" />
          {props?.title && (
            <h6 className="text-center" style={{ marginTop: "10px" }}>
              {props?.title}
            </h6>
          )}
        </div>
      </ModalHeader>

      <ModalBody className="modal-body">
        <p className="modal-text">{props.text}</p>
        {props.showInput && (
          <div className="input-section">
            <label htmlFor="confirmation-input">
              Please type <strong>{props.consultantId}</strong> to confirm
              deletion:
            </label>
            <input
              id="confirmation-input"
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              className="confirmation-input"
              placeholder="Enter ID"
            />
          </div>
        )}
      </ModalBody>

      <ModalFooter
        className={
          props.hideCancelButton
            ? "d-flex justify-content-center"
            : "modal-footer d-flex justify-content-center"
        }
      >
        {props.hideCancelButton ? (
          <Button
            isLoading={props.isLoading}
            disabled={props.isLoading}
            buttonTitle={props.isLoading ? "Loading..." : props.btn1Text}
            onClick={handleConfirm}
            className="warning outline"
          />
        ) : (
          <>
            {props.showInput ? (
              <>
                <Button
                  isLoading={props.isLoading}
                  disabled={!isConfirmed || props.isLoading}
                  buttonTitle={
                    props.isLoading
                      ? "Loading..."
                      : props.btn1Text || props.btn1TextYes
                  }
                  onClick={props.btn1Handler}
                  className={
                    props?.btn1TextYes ? "primary outline" : "error outline"
                  }
                />
                <Button
                  className="secondary outline"
                  type="reset"
                  disabled={props.isLoading}
                  onClick={props.onHide}
                >
                  {props?.btn2TextNo ? props?.btn2TextNo : "Cancel"}
                </Button>
              </>
            ) : (
              <>
                <Button
                  isLoading={props.isLoading}
                  disabled={props.isLoading}
                  buttonTitle={
                    props.isLoading
                      ? "Loading..."
                      : props.btn1Text || props.btn1TextYes
                  }
                  onClick={handleConfirm}
                  className={
                    props.isPaymentConfirmationModal || props?.btn1TextYes
                      ? "primary outline"
                      : "error outline"
                  }
                />
                <Button
                  className="secondary outline"
                  type="reset"
                  disabled={props.isLoading}
                  onClick={props.btn2Handler || props.onHide}
                >
                  {props?.btn2TextNo ? props?.btn2TextNo : "Cancel"}
                </Button>
              </>
            )}
          </>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
